import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { NgForm } from '@angular/forms';
import { MOBILECONNECTLABELS } from '../../_constants/constants';

import { McConnectService } from '../../_services/mcconnect.service';

export interface MobileConnectUpdateModel {
    title: string;   
    subValue: string;
    opcoValue: string;
    mcconnect:string;
    mcconnectStatus:string;
    mcconnectLastUpdatedAt:string;
    msisdn:string;      
}

@Component({
    templateUrl: 'mobile.connect.dialog.component.html',
    providers: [McConnectService]
})

export class MobileConnectComponent extends DialogComponent<MobileConnectUpdateModel, string>  {
    subValue: string;
    opcoValue: string;
    title: string;
    mcconnect:string;
    mcconnectStatus:string;
    mcconnectLastUpdatedAt:string;
    msisdn:string;
    mobileconnectlabels = MOBILECONNECTLABELS;      

    constructor(private ds: DialogService,private mcconnectService: McConnectService) {
        super(ds);                      
    }

    update(form: NgForm){                     
        this.mcconnectService.updateMcConnect(this.mcconnect, this.subValue, this.opcoValue, this.msisdn, this.ds);        
        this.close();
    }
}




// WEBPACK FOOTER //
// ./src/app/details/mobile-connect/mobile.connect.dialog.component.ts